import React, { useEffect } from 'react'
import './StreamerCards.css'
import dayjs from 'dayjs'
import { Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'

import { addDefaultSrc } from '../../utils/imgUtil'

// Component for the ribbon with the streamers and their streams on the main page of the application
const StreamerCards = ({
  streamers,
  fetchStreamerCards
}) => {
  useEffect(() => {
    fetchStreamerCards()
  }, [])

  return (
    <div className='streamer_card_container'>
      {streamers.map(streamer =>
        <div className='streamer_card' name="streamerCardDiv" key={streamer.id}>
          <Grid container spacing={24} style={{ width: '300px' }}>
            <Grid item xs={6} >
              <Link to={`/streamer-card/${streamer.id}`} className='link-wrapper'>
                <img src={`data:image/jpeg;base64,${streamer.avatarBytes}`}
                  onError={addDefaultSrc}
                  width='140' height='140' className='account-avatar center-block' alt=""/>
                <div>
                  <h4 className='text-account-header text-account-header-name'>{streamer.name}</h4>
                  <h4 className='text-account-header text-account-header-sh-desc'>{streamer.shortDescription}</h4>
                </div>
                <p style={{ textAlign: 'justify', marginLeft: '5px', fontSize: '11px' }}>{streamer.description}</p>
              </Link>
            </Grid>
            <Grid item xs={6}>
              {streamer.activeStreams.map(stream => {
                const startDate = new Date(`${stream.startDate}Z`)
                return (
                  <Link to={`/stream-card/${streamer.id}/${stream.id}`} key={stream.id} className='link-wrapper'>
                    <div>
                      <img src={`data:image/jpeg;base64,${stream.avatarBytes}`} onError={addDefaultSrc}
                        width='160' height='85' className='account-avatar center-block' alt=""/>
                      <div>
                        <h4 style={{ margin: '3px', fontSize: '14px', textAlign: 'center', fontWeight: 'bold' }}>
                          <a href='#'>{stream.title}</a>
                        </h4>
                        <h4 style={{ margin: '3px', fontSize: '12px', textAlign: 'center', fontStyle: 'italic' }}>
                          {dayjs(startDate).format('LLL')}
                        </h4>
                      </div>
                      <br/>
                    </div>
                  </Link>)
              })
              }
            </Grid>
          </Grid>
        </div>)}
    </div>)
}

export default StreamerCards
